import AccountScreen from 'screens/Account';
import ArticleDetailScreen from 'screens/ArticleDetail';
import CollectionScreen from 'screens/Collection';
import DebugScreen from 'screens/Debug';
import Error500Screen from 'screens/Error500';
import Error404Screen from 'screens/Error404';
import GeoBlock from 'screens/GeoBlock';
import LatestEpisodeScreen from 'screens/LatestEpisode';
import LiveScreen from 'screens/Live';
import LoadingScreen from 'screens/Loading';
import MVPDScreen from 'screens/MVPD';
import ResetPasswordScreen from 'screens/ResetPassword';
import SearchScreen from 'screens/Search';
import SeriesDetailScreen from 'screens/SeriesDetail';
import ContentDetailScreen from 'screens/ContentDetail';
import ShowsScreen from 'screens/Shows';
import SignInScreen from 'screens/SignIn';
import SiteMapScreen from 'screens/SiteMap';
import SubscriptionScreen from 'screens/Subscription';
import WatchScreen from 'screens/Watch';

import generator from './routes-generator';

export default generator({
  AccountScreen,
  ArticleDetailScreen,
  CollectionScreen,
  ContentDetailScreen,
  DebugScreen,
  Error500Screen,
  Error404Screen,
  GeoBlock,
  LatestEpisodeScreen,
  LiveScreen,
  LoadingScreen,
  MVPDScreen,
  ResetPasswordScreen,
  SearchScreen,
  SeriesDetailScreen,
  ShowsScreen,
  SignInScreen,
  SiteMapScreen,
  SubscriptionScreen,
  WatchScreen,
});
